export class EventQueue {
    constructor() {
        this.queue = [];
        this.running = false;
    }
    enqueue(task, callback) {
        this.queue.push({ func: task, callback });
        this.startNext();
    }
    enqueueToHead(task, callback) {
        this.queue.unshift({ func: task, callback });
        this.startNext();
    }
    done() {
        this.running = false;
        this.startNext();
    }
    async startNext() {
        if (this.running) {
            return;
        }
        if (this.queue.length === 0) {
            this.running = false; // No more tasks to process
            return;
        }
        this.running = true;
        // Take the next task from the queue and execute it
        const { func, callback } = this.queue.shift(); // Get the first task (guaranteed non-null due to `shift`)
        const that = this;
        const cb = callback
            ? function () {
                const args = arguments;
                callback(...args);
                that.done();
            }
            : () => this.done();
        try {
            // Execute the function with the callback and its arguments
            await func(cb);
        }
        catch (error) {
            console.error('Error executing task:', error);
            this.done();
        }
    }
    isRunning() {
        return this.running;
    }
}
